import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmModal = ({ show, onConfirm, onCancel, message, loading = false }) => (
  <Modal show={show} onHide={onCancel} centered backdrop={loading ? 'static' : true}>
    <Modal.Header closeButton={!loading}>
      <Modal.Title>Tasdiqlash</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>{message}</p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onCancel} disabled={loading}>
        Bekor qilish
      </Button>
      <Button variant="danger" onClick={onConfirm} disabled={loading}>
        {loading ? 'Yuborilmoqda...' : 'Tasdiqlash'}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ConfirmModal; 